
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "Form1",
  components: {},
  props: {
    callbackdata: {
      type: Object,
      default: false,
    },
  },
  watch: {
    callbackdata(newone, oldone) {
      console.log("Form1组件的旧数据：");
      console.log(oldone);
      console.log("Form1组件的新数据：");
      console.log(newone);
      if (newone.input_CarSignNum != this.inputModel.input_CarSignNum) {
        this.inputModel.input_CarSignNum = newone.input_CarSignNum;
      }
    },
  },
})
export default class extends Vue {
  private inputModel: inputDataModel_BubblePackage = {
    input_ScanCode: "",
    input_CarSignNum: "",
  };
  mounted() {
    console.log("加载揽收Form1组件");
    this.$emit("get-form1-value", this.inputModel);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  public input_PutInWeightVisible = false;
  public input_OverWeightValueVisible = false;
  public RecheckBagWeightFunc(result) {
    console.log("包重量复核checkbox点击:" + result);
    if (result) {
      this.input_OverWeightValueVisible = true;
    } else {
      this.input_OverWeightValueVisible = false;
    }
  }
  public linecodenameDialogVisible = false;
  public findlinecodename() {
    console.log("|FUNC|findlinecodename");
    console.log(this.linecodenameDialogVisible);
    this.linecodenameDialogVisible = true;
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    console.log(row);
    // this.$refs.singleTable.setCurrentRow(row);
    this.$refs.singleTable[0].setCurrentRow();
  }

  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
}
